var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapClasses},[_vm._t("default"),_vm._v(" "),(!_vm.hasSlot)?_vm._l((_vm.data),function(radio){return _c('v-radio',{key:radio.value,attrs:{"type":_vm.type,"class-name":_vm.radioClasses,"disabled":radio.disabled,"label":radio.value}},[_c('span',[_vm._v(_vm._s(radio.text))])])}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf1b0266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vb/components/radio/radio-group.vue
// module id = null
// module chunks = 